package com.solevo.dist.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.solevo.dist.navigation.Screen

@Page
@Composable
fun Index() {
    val context = rememberPageContext()
    LaunchedEffect(Unit) {
        context.router.navigateTo(Screen.Orders.route)
    }
}
